// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"445":"1bfc9850","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"445":"cdf8f5d3c71d47386d6c","678":"2693b54a76cd0cf96590","883":"8a5882abb8d82326f957"}[chunkId] + ".js";
};